import { USStateAbbrev, USStateName } from '@mosey/utils/constants/us-states';

export enum ResolverType {
  // Setup
  Review = 'review',
  Assessment = 'assessment', // AKA Configure
  Setup = 'setup',

  // All other tasks
  Question = 'question',
  Todo = 'todo',
  Overdue = 'overdue',
  Done = 'done',
  DoneQuestions = 'done_questions',
  Automated = 'automated',
  Managed = 'managed',
  InProgress = 'in_progress',
  Handbook = 'handbook',
}

export type ResolverRouteParams = {
  resolverType?: ResolverType;
  countryId?: 'usa';
  // TODO: Type this as USStateAbbrev
  locationId?: string;
};

export type LocationResolverRouteParams = ResolverRouteParams & {
  countryId: 'usa';
  // TODO: Type this as USStateAbbrev
  locationId: string;
};

export type TaskRouteParams = ResolverRouteParams & {
  taskId: string;
};

export type TasksFrameworkLocation = {
  code: USStateAbbrev;
  name: USStateName;
} | null;
